import React from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';



class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { address: this.props.address };
  }
 
  handleChange = address => {
    this.setState({ address });
    this.props.onChange(address)
  };

  handleSelect = address => {
    this.setState({ address });
    geocodeByAddress(address)
      .then( results => getLatLng(results[0]))
      .then(latLng => {
        this.props.onSelect(latLng,address)
        
      })
      .catch(error => console.error('Error', error));
  };

 
  
 
  render() {
    return (
      <PlacesAutocomplete
        highlightFirstSuggestion={true}
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => { 
            let dropdown = ''
            if(!loading && suggestions.length > 0) {
                dropdown = (<div className="autocomplete-dropdown-container">
                {suggestions.map(suggestion => {
                    const className = suggestion.active
                    ? 'suggestion-item--active'
                    : 'suggestion-item';
                    // inline style for demonstration purpose
                    const style = suggestion.active
                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                    return (
                    <div  key={suggestion.index}
                        {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                        })}
                    >
                        <span>{suggestion.description}</span>
                    </div>
                    );
                })}
                </div>)
            }
            return(
            <div className="position-relative">
                <input
                {...getInputProps({
                    placeholder: 'Enter City or Zip Code ...',
                    className: 'form-control'
                })}
                />
                {dropdown}
            </div>
            )
        }
        }
      </PlacesAutocomplete>
    );
  }
}

export default LocationSearchInput;